// Final steps section form field enum
export enum FinalStepsFormField {
  FINAL_STEPS_INTERNAL_NOTES = 'final-steps/internal-notes',
  FINAL_STEPS_CLIENT_REPRESENTATIVE_SIGNATURE = 'final-steps/client-representative-signature'
}
